/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Segment_Event_Group_Segment_Button_LabelInputs */



/**
* | output |
* | --- |
* | "Segment group" |
*
* @param {Segment_Event_Group_Segment_Button_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const segment_event_group_segment_button_label = /** @type {((inputs?: Segment_Event_Group_Segment_Button_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Segment_Event_Group_Segment_Button_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Segmenter le groupe")
	if (locale === "de") return /** @type {LocalizedString} */ ("Segmentgruppe")
	if (locale === "it") return /** @type {LocalizedString} */ ("Gruppo di segmenti")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Группа сегментов")
	if (locale === "es") return /** @type {LocalizedString} */ ("Grupo de segmentos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("细分市场")
	if (locale === "ja") return /** @type {LocalizedString} */ ("セグメントグループ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("खंड समूह")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Grupo de segmentos")
	return /** @type {LocalizedString} */ ("Segment group")
});